/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
/* eslint-disable quotes */
// eslint-disable-next-line quotes
import Swiper, {
  Autoplay,
  Navigation,
  Pagination,
  Thumbs,
  EffectFade,
  // eslint-disable-next-line quotes
} from "swiper";

Swiper.use([Autoplay, Navigation, Pagination, Thumbs, EffectFade]);
export default {
  init() {
    new Swiper("#slide-gallery", {
      slidesPerView: "auto",
      loop: true,
      autoplay: true,
      // centeredSlides: true,
      // spaceBetween: 15,
      // grabCursor: true,
      // breakpoints: {
      //   769: {
      //     slidesPerView: 2,
      //     // slidesPerGroup: 2,
      //   },
      // },
      navigation: {
        // eslint-disable-next-line quotes
        nextEl: ".slider__button-next",
        // eslint-disable-next-line quotes
        prevEl: ".slider__button-prev",
      },
    });
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/singleExplores.js